import type {Mapper} from 'framework';
import type {WorkoutTemplate, WorkoutTemplateExercise} from '../../domain/workout-template';
import type {WorkoutTemplateDto} from '../dto/workout.dto';

export class WorkoutTemplateDtoToWorkoutTemplateMapper implements Mapper<
  WorkoutTemplateDto,
  WorkoutTemplate
> {
  transform(dto: WorkoutTemplateDto): WorkoutTemplate {
    return {
      id: dto.id,
      name: dto.name,
      notes: dto.notes,
      exercises: dto.exercises.map(
        (exercise): WorkoutTemplateExercise => ({
          id: exercise.id,
          exerciseId: exercise.exerciseId,
          exerciseName: exercise.exerciseName,
          orderIndex: exercise.orderIndex,
          groupId: exercise.groupId,
          targetSets: exercise.targetSets,
          targetReps: exercise.targetReps,
          targetWeightKg: exercise.targetWeightKg,
          targetRestSeconds: exercise.targetRestSeconds,
          notes: exercise.notes,
        }),
      ),
      createdAt: String(dto.createdAt),
      updatedAt: String(dto.updatedAt),
    };
  }
}
